import React from "react";
import { useState } from "react";
import { motion } from "framer-motion";
import { useParallax } from "react-scroll-parallax";
import Lottie from "lottie-react";
import animationData from "../../MyAnimations/Animation - 1743877059086.json";

// Animation Variants
const imageVariant = {
  hidden: { x: "100vw", opacity: 0 }, // Image moves in from the right
  visible: { x: 0, opacity: 1, transition: { duration: 1.5, ease: "easeOut" } },
};

const fadeUpVariant = {
  hidden: { y: 50, opacity: 0 },
  visible: (delay) => ({
    y: 0,
    opacity: 1,
    transition: { duration: 0.8, ease: "easeOut", delay },
  }),
};


const CompitativeCodingSection = () => {
  const parallax = useParallax({ translateY: [-24, 24], rootMargin: 0 });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 670);


  return (
    <section className="work-area pt-110 bg-[#292930] text-white mb-20" style={{paddingTop : isMobile && 50, paddingBottom : isMobile && 50}}>
      <div className="container">
        <div className="content-wrapper" style={{ marginBottom: "50px" }}>
          {/* Left Content */}
          <motion.div
            className="text-container"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <motion.h2 variants={fadeUpVariant} custom={0.2}>
            <div className="section-title title-style-two white-title mb-30">
                <span className="sub-title">Problem Solving</span>
                <h2 className="title" style={{fontSize : isMobile ? "30px" : "40px"}}>Competitive Coding</h2>
              </div>
            </motion.h2>

            {/* Icons */}
            <motion.div className="tech-icons" variants={fadeUpVariant} custom={0.4}>
              <img src="https://pathrise-website-guide-wp.s3.us-west-1.amazonaws.com/guides/wp-content/uploads/2019/05/10175228/images-11.png" alt="LeetCode" />
              <img src="https://miro.medium.com/v2/resize:fit:1100/format:webp/0*ilw552fVUGbwIzbE.jpg" alt="Geekforgeeks" />
              <img src="https://images.crunchbase.com/image/upload/c_pad,h_170,w_170,f_auto,b_white,q_auto:eco,dpr_2/zruiknbedz8yqafxbazb" alt="Codechef" />
              <img src="https://play-lh.googleusercontent.com/zaldniLc2XTBhNlCDR4hcD5bcRYHZ56_lO0yA2Qu-cADShy1_HDWrICSvv0EPTX79WY=w480-h960-rw" alt="Codeforces" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/4/40/HackerRank_Icon-1000px.png" alt="HackerRank" />

            </motion.div>
            {/* Content */}
            <motion.ul className="info-list" >
              <motion.li variants={fadeUpVariant} custom={1.0} style={{color :"#b8b8c5"}}>
                🏆 Ranked in the top 5% on LeetCode with 500+ problems solved across all difficulty levels
              </motion.li>
              <motion.li variants={fadeUpVariant} custom={1.5}style={{color :"#b8b8c5"}}>
                🏆 Achieved 5-star rating on HackerRank in Problem Solving and Algorithms specializations
              </motion.li>
              <motion.li variants={fadeUpVariant} custom={2.0}style={{color :"#b8b8c5"}}>
                🏆 Participated in 50+ coding contests with peak rating of Specialist (1400+) on Codeforces
              </motion.li>
              <motion.li variants={fadeUpVariant} custom={2.5}style={{color :"#b8b8c5"}}>
                🏆 Optimized solutions for complex algorithmic challenges reducing time complexity from O(n²) to O(n log n)
              </motion.li>
            </motion.ul>
          </motion.div>

          {/* Right Image */}
          <motion.div
            className="image-container"
            variants={imageVariant}
            initial="hidden"
            animate="visible"
            style={{ marginTop: "-50px" }}
          >
            <Lottie animationData={animationData} loop={true} style={{ width: !isMobile ? "90%" : "100%", marginTop : !isMobile ? "100px" : "30px", marginLeft : !isMobile ? "50px" : "0px"}} />
          </motion.div>
        </div>
      </div>

      {/* Styling */}
      <style jsx>{`
        .database-section {
          padding: 4rem 2rem;
          background-color: #292930;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
        }

        .content-wrapper {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
        }

        .image-container {
          flex: 1;
          display: flex;
          justify-content: center;
          max-width: 50%;
        }

        .image-container img {
          width: 100%;
          max-width: 500px;
        }

        .text-container {
          flex: 1;
          max-width: 50%;
          text-align: left;
        }

        h2 {
          font-size: 2rem;
          color: white;
          margin-bottom: 1rem;
        }

        .tech-icons {
          display: flex;
          gap: 10px;
          margin-bottom: 1rem;
        }

        .tech-icons img {
          width: 40px;
          height: 40px;
        }

        .info-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .info-list li {
          font-size: 1rem;
          color: white;
          margin-bottom: 0.75rem;
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .content-wrapper {
            flex-direction: column-reverse;
            text-align: center;
          }

          .image-container,
          .text-container {
            max-width: 100%;
          }

          .text-container {
            margin-top: 2rem;
          }
        }
      `}</style>

      <div className="work-shape-wrap">
        <img src="/img/images/work_shape05.png" alt="" />
        <img src="/img/images/work_shape04.png" alt="" ref={parallax.ref} />
        <img src="/img/images/work_shape03.png" alt="" />
        <img src="/img/images/work_shape02.png" alt="" />
        <img src="/img/images/work_shape01.png" alt="" />
      </div>
    </section>
  );
};

export default CompitativeCodingSection;